/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Modality_QuestionInputs */

const en_us2_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What have you trained before?`)
};

const pt_br2_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você já treinou?`)
};

const es_419_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué has entrenado antes?`)
};

const pt_pt2_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que já treinaste?`)
};

const fr_fr2_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'as-tu déjà pratiqué ?`)
};

const de_de2_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was hast du schon trainiert?`)
};

const it_it2_improve_modality_question = /** @type {(inputs: Improve_Modality_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa hai praticato in passato?`)
};

/**
* | output |
* | --- |
* | "What have you trained before?" |
*
* @param {Improve_Modality_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_modality_question = /** @type {((inputs?: Improve_Modality_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Modality_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_modality_question(inputs)
	if (locale === "es-419") return es_419_improve_modality_question(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_modality_question(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_modality_question(inputs)
	if (locale === "de-DE") return de_de2_improve_modality_question(inputs)
	if (locale === "it-IT") return it_it2_improve_modality_question(inputs)
	return en_us2_improve_modality_question(inputs)
});
export { improve_modality_question as "improve.modality.question" }